import { Table } from '@economist/design-system/dist/umd/common';
import * as React from 'react';
export default {
  Table,
  React
};